export default {
  toastClassName: 'styled-toast',
  closeButtonClassName: 'styled-button',
  transitionDuration: { enter: 0, leave: 0 },
  hideProgressBar: true,
  draggable: false,
  closeOnClick: false,
};
